"use strict";

const ClipboardPort = {
  add: function (app) {
    app.ports.clipboardCopyPort.subscribe(async function (text) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          // Fallback to the legacy method for local
          const textareaToCopyFrom = document.createElement("textarea");
          textareaToCopyFrom.value = text;
          textareaToCopyFrom.style.position = "fixed";
          textareaToCopyFrom.style.left = "-999999px";
          textareaToCopyFrom.style.top = "-999999px";
          window.document.body.appendChild(textareaToCopyFrom);
          textareaToCopyFrom.focus();
          textareaToCopyFrom.select();
          window.document.execCommand("copy");
          window.document.body.removeChild(textareaToCopyFrom);
        }
      } catch (err) {
        console.error("Failed to copy text to clipboard:", err);
      }
    });
  },
};

module.exports = ClipboardPort;
